/**
 * @module app.pm
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IQueryLoadOptions, IApiQueryResults, IApiSettingsResults } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { ApiQuery } from 'app/shared/lib/essette-api';
import * as PM from 'app/pm/models/essette-api';

@transient()
@autoinject()
export class CampaignService {

    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }

    public async get<T>(query: ApiQuery): Promise<IApiQueryResults<T>> {
        return await this.api.get(query) as IApiQueryResults<T>;
    }


    ////****************** Settings *************************************************////
    public async loadCampaignSettings(includes: string[] = []): Promise<IApiSettingsResults> {
        return this.api.get(
            this.api.settings('pm/campaigns').include(...includes)
        );
    }


    ////****************** Queries **************************************************////


    ////****************** Loads ****************************************************////
    public async loadCampaigns(options?: Partial<IQueryLoadOptions>, includes: string[] = []): Promise<IApiQueryResults<PM.Campaign>> {
        const query = this.api
            .query('pm/campaigns')
            .applyStandardLoadOptions(options)
            .include(...includes);

        return await this.api.get(query);
    }

    public async loadCandidateByDetail(detailProperty: string, detailId: string, includes: string[] = []): Promise<IApiQueryResults<PM.Candidate>> {
        const query = this.api
            .query('pm/candidates/')
            .filterExists(detailProperty, q => q.filterIdentifier('id', detailId))
            .top(1)
            .include(...includes);

        return await this.api.get(query);
    }

    public async loadCandidatesByMemberId(memberId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<PM.Candidate>> {
        const query = this.api
            .query('pm/candidates')
            .applyStandardLoadOptions(options)
            .filterString('member.id', memberId)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

}

